import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { selectCurrentUser } from "store/user/user.selector";
import HeaderUserDropdown from "./user-dropdown.component";

function HeaderProfile() {
  const user = useSelector(selectCurrentUser);
  return user == null ? (
    <Link
      className="rounded-lg bg-orange-600 py-2.5 px-8 text-center font-semibold text-white shadow-orange-600 transition-all hover:bg-orange-700"
      to="/login">
      Log in
    </Link>
  ) : (
    <HeaderUserDropdown />
  );
}

export default HeaderProfile;
